import { ALL_ROWS_PAGE_SIZE } from './pagedList.js'

/**
 * **사업장 셀렉트의 조회 규약 한 곳** — 의존성이 없는 순수 모듈이다(Vue·Element·`@/` 별칭 금지).
 *
 * 네 화면이 사업장 셀렉트를 채우려고 목록 API(`GET /cust`)를 부른다 — 사업장 관리·매장 트리·
 * 사업장 계정 관리·오더톡 플레이스. 셋은 사업장명 원격 검색이고 하나는 디바운스가 붙은
 * 자동완성이지만, **「이 조건의 사업장 전부를 셀렉트에 꽂는다」는 한 가지 일**이다.
 *
 * 그 목록이 서버 페이징으로 바뀌면 네 벌이 동시에 틀린다: `this.cust` 가 배열이 아니게 되고,
 * 페이지 UI 가 없는 셀렉트에는 51번째 사업장으로 넘어갈 수단이 없다. 그래서 전량 모드
 * ([ALL_ROWS_PAGE_SIZE])를 이 한 곳이 붙인다 — 화면마다 「충분히 큰 수」를 적으면 그것은
 * 상한을 추측한 값이라 사업장이 늘면 조용히 잘린다.
 *
 * 매장 축의 같은 자리는 `utils/storeOptions`(`GET /store/combo`)다. 사업장은 목록과 셀렉트가
 * 같은 URL 을 쓴다 — 행이 165개뿐이고 셀렉트가 목록에 없는 필드를 요구하지 않기 때문이다.
 */

/** 사업장 셀렉트의 공급원 — 목록 화면과 **같은 URL** 이고, 다른 것은 페이지 크기뿐이다 */
export const CUST_OPTIONS_API = '/cust'

/**
 * 사업장 셀렉트용 조회 조건 — **전량**이다(페이지 UI 가 없는 소비자).
 *
 * 기본은 `useYn: ''`(전체)다. 탈퇴한 사업장도 골라야 하는 화면이 셋이라 그쪽이 기본이고,
 * **사용 중만** 필요한 화면은 `useYn: 'Y'` 를 스스로 적는다 — 종전에 그 화면은 `useYn` 을 아예
 * 안 보냈고 서버 기본값이 `'Y'` 라 같은 결과였다. 값을 적어 두면 그 뜻이 요청에 남는다.
 *
 * 매번 새 객체를 돌려준다. 호출부가 축을 덧붙여도 다음 호출이 영향받지 않아야 한다.
 * 응답을 배열로 푸는 것은 `utils/pagedList.pageRows` 다(여기서 다시 만들지 않는다).
 *
 * @param {object} [over] 화면이 덧붙이는 조건(`custNm`·`useYn` …)
 * @returns {object} 요청에 실을 새 객체
 */
export function custOptionsQuery(over) {
  return Object.assign({ custNm: '', useYn: '' }, over || {}, { pageSize: ALL_ROWS_PAGE_SIZE })
}
